module.exports = "/_next/static/videos/11-b39add70a74fd6b7e800c5c1c75bc15a.webm";